module.exports = __webpack_public_path__ + "static/media/na.74257fb2.svg";